<template>

    <div class="row">
        <div class="col-md-6" :class="{'border-right' : !mobile}">
            <div class="row">
                <div class="col-lg-6 col-md-6 col-sm-8 col-xs-10 offset-lg-3 offset-md-3 offset-sm-2 offset-xs-1">
                    <h3 class="chart--title text-center">Aging Stock Tertinggi</h3>
                    <div class="row" v-if="data">
                        <div class="col-6" style="display: flex; align-items: center; justify-content: flex-end;">
                            <img src="@/assets/img/Highlights/Total.png" style="width:75%;"/>
                        </div>
                        <div class="col-6">
                            <table>
                                <tr>
                                    <th colspan="2">{{ data.aging_stock_tertinggi.series ? data.aging_stock_tertinggi.series : '-'  }}</th>
                                </tr>
                                <tr>
                                    <td>Warna</td>
                                    <th>{{ data.aging_stock_tertinggi.color_desc ? data.aging_stock_tertinggi.color_desc : '-'  }}</th>
                                </tr>
                                <tr>
                                    <td>Aging Stock</td>
                                    <th>{{ data.aging_stock_tertinggi.aging_day != null ? data.aging_stock_tertinggi.aging_day : '-'  }} Days</th>
                                </tr>
                                <tr>
                                    <td>Tgl SPG</td>
                                    <th>{{ data.aging_stock_tertinggi.tgl_masuk ? data.aging_stock_tertinggi.tgl_masuk : '-'  }}</th>
                                </tr>
                            </table>
                        </div>
                    </div>
                    <div style="min-height: 150px; display: flex; align-items: center; justify-content: center;" v-else>
                        <p style="margin: 0; font-size: 40px; text-shadow: 2px 2px 2px grey">Loading...</p>
                    </div>
                </div>
            </div>
        </div>
        <div class="col-md-6">
            <div class="row">
                <div class="col-lg-6 col-md-6 col-sm-8 col-xs-10 offset-lg-3 offset-md-3 offset-sm-2 offset-xs-1">
                    <h3 class="chart--title text-center">Aging Stock Terendah</h3>
                    <div class="row" v-if="data != null">
                        <div class="col-6" style="display: flex; align-items: center; justify-content: flex-end;">
                            <img src="@/assets/img/Highlights/Total.png" style="width:75%;"/>
                        </div>
                        <div class="col-6">
                            <table>
                                <tr>
                                    <th colspan="2">{{ data.aging_stock_terendah.series ? data.aging_stock_terendah.series : '-'  }}</th>
                                </tr>
                                <tr>
                                    <td>Warna</td>
                                    <th>{{ data.aging_stock_terendah.color_desc ? data.aging_stock_terendah.color_desc : '-'  }}</th>
                                </tr>
                                <tr>
                                    <td>Aging Stock</td>
                                    <th>{{ data.aging_stock_terendah.aging_day != null ? data.aging_stock_terendah.aging_day : '-'  }} Days</th>
                                </tr>
                                <tr>
                                    <td>Tgl SPG</td>
                                    <th>{{ data.aging_stock_terendah.tgl_masuk ? data.aging_stock_terendah.tgl_masuk : '-'  }}</th>
                                </tr>
                            </table>
                        </div>
                    </div>
                    <div style="min-height: 150px; display: flex; align-items: center; justify-content: center;" v-else>
                        <p style="margin: 0; font-size: 40px; text-shadow: 2px 2px 2px grey">Loading...</p>
                    </div>
                </div>
            </div>
        </div>
    </div>

</template>

<script>
    export default {
        data () {
            return {
                mobile : this.isMobile(),
            }
        },
        props : ['data'],
        mounted () {

        },
        methods : {

        }
    }
</script>

<style scoped>
    .border-right {
        border-right: 1px solid #F2F2F2;
    }

    table tr th {
        font: normal normal medium 12px/13px Ubuntu;
        color: #707070;
    }

    table tr td {
        font: normal normal medium 10px/11px Ubuntu;
        color: #707070;
        padding-right: 10px;
    }
</style>